import { configureStore } from '@reduxjs/toolkit';
import common from './common/common_reducer';
import booking from './booking/booking_reducer';
import dispatchData from './cargoDispatch/dispatch_reducer';
import acountingReducer from './Acounting/acounting_reducer'
import reports from './reports/reports_reducer'
import BranchTransferReceiveReducer from './branchTransferReceive/branchReceive_reducer';
import generalSettingReducer from './generalSetting/GSReducer';
import branchAndUserMasterReducer from "./branchAndUserMaster/BUMaster_reducer"
const store = configureStore({
    reducer: {
        common,
        booking,
        BranchTransferReceiveReducer,
        dispatchData,
        reports,
        acountingReducer,
        generalSettingReducer,
        branchAndUserMasterReducer
    }
});

export default store;